import { useCallback } from 'react';
import { fileAPI } from '../../../../entities/file/api/api';
import { notificationError } from '../../../../components/Notifications/callNotifcation';
import { MB } from '../../../types/convertBytes';
import File from '../../Editor/utils/impl/File';

export const useUploadImage = () => {
	const [saveUserFile] = fileAPI.useSaveUserFileMutation();

	return useCallback(
		(onProgress: VoidFunction): Promise<string> => new Promise((resolve, reject) => {
			const fileHandler = new File();

			fileHandler.getPictureBase64FromFile(async (name, base64, size) => {
				onProgress();

				if (!name) {
					console.error('Не выбран файл');
					return reject(new Error('Ошибка загрузки изображения: файл не выбран'));
				}

				if (size > MB(20)) {
					notificationError('Сохранение файла', 'Загрузка файлов более 20MB запрещена');
					return reject(new Error('Файл превышает 20MB'));
				}

				try {
					const response = await saveUserFile({ name, bytes: base64 }).unwrap();
					resolve(response.id);
				} catch (error: unknown) {
					if (error instanceof Error) {
						console.error('Ошибка при загрузке файла:', error.message);
						reject(new Error(`Ошибка загрузки изображения: ${error.message}`));
					} else {
						console.error('Неизвестная ошибка при загрузке файла');
						reject(new Error('Неизвестная ошибка загрузки изображения'));
					}
				}
			});
		}),
		[saveUserFile],
	);
};
